/* ────────────────────────────────────────────────────────────
 * Sizing and shape
 * Everything in the toolbar is 32px tall with an 8px radius, so icon
 * buttons, text buttons and Save line up on one baseline.
 * ──────────────────────────────────────────────────────────── */

// Square icon buttons with a rounded-square hover (instead of MUI's circle)
export const toolbarIconButtonSx = {
  width: 32,
  height: 32,
  p: 0,
  m: 0,
  borderRadius: '8px',
  lineHeight: 0,
};
export const toolbarIconProps = { sx: { fontSize: 20, display: 'block' } };

// Shared shape for every text button in the toolbar
export const toolbarButtonBaseSx = {
  height: 32,
  minWidth: 0,
  px: 1.25,
  borderRadius: '8px',
  textTransform: 'none',
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1,
  whiteSpace: 'nowrap',
  flexShrink: 0,
};

// Neutral outlined button (Docs). Goes blue while its menu is open.
export const toolbarOutlinedButtonSx = (active = false) => ({
  ...toolbarButtonBaseSx,
  color: active ? 'primary.main' : 'text.primary',
  borderColor: active ? 'primary.main' : 'divider',
  '& .MuiButton-startIcon': { mr: 0.5, color: active ? 'primary.main' : 'text.secondary' },
  '& .MuiButton-endIcon': { ml: 0.25, color: active ? 'primary.main' : 'text.secondary' },
  '&:hover': {
    borderColor: active ? 'primary.main' : 'text.disabled',
    backgroundColor: 'action.hover',
  },
});

export const toolbarDividerSx = { mx: 0.75, my: 0.75 };

/* ────────────────────────────────────────────────────────────
 * Menus (Case, Download)
 * ──────────────────────────────────────────────────────────── */

export const toolbarMenuPaperSx = {
  mt: 0.5,
  minWidth: 220,
  borderRadius: '8px',
  border: '1px solid',
  borderColor: 'divider',
  boxShadow: '0 4px 16px rgba(0, 0, 0, 0.08)',
};

export const toolbarMenuSx = {
  '& .MuiMenuItem-root': { fontSize: 13, minHeight: 36 },
  '& .MuiListItemText-primary': { fontSize: 13 },
  '& .MuiListItemText-secondary': { fontSize: 12 },
  '& .MuiListItemIcon-root': { minWidth: 30, color: 'text.secondary' },
};

export const toolbarMenuIconSx = { fontSize: 18 };
